import { useRef, useState } from 'react'

/**
 * Одна операция за раз. Двойной клик отсекается рефом: флаг загрузки доезжает до кнопки
 * только следующим рендером, а цена лишнего клика — вторая заявка (и второй расход
 * антиспама). `guarded(task)` держит реф на время `task`; повторный вход — no-op.
 */
export const useGuardedTask = () => {
  const inFlight = useRef(false)
  const [isBusy, setIsBusy] = useState(false)

  const guarded = async (task: () => Promise<void>): Promise<void> => {
    if (inFlight.current) return
    inFlight.current = true
    setIsBusy(true)
    try {
      await task()
    } finally {
      inFlight.current = false
      setIsBusy(false)
    }
  }

  return { guarded, isBusy }
}
